import _ from "lodash";
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ButtonDropdown from "UIComponents/ButtonDropdown";
import CheckboxGroup from "UIComponents/GroupSelectDropdown";
import { Tag } from "UIComponents/Tags";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import classes from "./SelectDropdownButton.scss";
import classNames from "classnames";
import { colors } from "@toddle-edu/ds-theme";
import { CaretDownFilled, CaretUpFilled } from "@toddle-edu/ds-icons";

const dropDownStyle = {
  containerStyle: {
    width: "100%",
    flex: 1,
    minHeight: 0,
    marginTop: "24px",
    borderRadius: "4px",
    marginBottom: "8px",
    maxHeight: "368px",
    overflowY: "auto",
    padding: "24px",
  },
  buttonParentStyle: {
    width: "100%",
    flexDirection: "column",
    height: "100%",
  },
  parentContainerStyle: {
    height: "100%",
  },
};

const checkBoxStyle = {
  checkboxItemLabelStyle: {
    color: colors.textDefault,
  },
};

const tagStyle = {
  container: {
    borderRadius: "4px",
    padding: "4px 8px",
    marginLeft: "4px",
  },
  label: {
    color: colors.textSubtle,
  },
};
class SelectDropdownButton extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: true,
    };
  }
  removeOption = (item, event) => {
    if (event) event.stopPropagation();
    const updatedValues = _.filter(this.props.value, id => id != item.value);
    this.updateValue(updatedValues);
  };

  getSelectedTags = () => {
    const { options, value } = this.props;
    const selectedTags = [];
    _.forEach(options, group => {
      _.forEach(group.options, item => {
        if (
          _.includes(value, item.value) &&
          !_.find(selectedTags, tagItem => tagItem.value === item.value)
        )
          selectedTags.push(item);
      });
    });
    return selectedTags;
  };

  TagList = ({ selectedTags, styles, inlineView, tagTheme }) => {
    const { tagStyle } = this.props;
    const { placeholder } = this.props;
    const tag = item => (
      <Tag
        styles={tagStyle}
        item={item}
        key={item.value}
        selected={true}
        removeOption={this.removeOption}
        showCloseButton={true}
        theme={tagTheme}
      />
    );
    return !_.isEmpty(selectedTags) ? (
      inlineView ? (
        <Fragment>{_.map(selectedTags, item => tag(item))}</Fragment>
      ) : (
        <div
          style={{ ...(styles.tagListContainer || {}) }}
          className={classes.tagListContainer}
        >
          {_.map(selectedTags, item => tag(item))}
        </div>
      )
    ) : (
      <div className={classes.placeholderText}>{placeholder}</div>
    );
  };

  onUpdateShowDropDown = (value, showDropdown) => {
    this.setState({ showDropdown: showDropdown });
  };

  renderButtonComponent = ({
    showErrorText,
    showArrow,
    inlineView,
    tagTheme,
    value,
  }) => {
    const { tagStyle, handleFocus, error } = this.props;
    const containerStyles = {
      flexDirection: inlineView ? "row" : "column",
    };

    const containerClasses = classNames({
      [classes.buttonContainer]: true,
      [classes.focusContainer]: !this.state.showDropdown,
      [classes.errorContainer]: !!error,
    });
    return (
      <Fragment>
        <div className={containerClasses}>
          <div
            className={classes.buttonInnerContainer}
            style={containerStyles}
            onClick={handleFocus}
          >
            {this.TagList({
              styles: tagStyle,
              selectedTags: value,
              inlineView: inlineView,
              tagTheme: tagTheme,
            })}
          </div>
          {showArrow && (
            <div className={classes.rightContainer}>
              <div className={classes.arrowContainer} onClick={handleFocus}>
                {this.state.showDropdown ? (
                  <CaretDownFilled />
                ) : (
                  <CaretUpFilled />
                )}
              </div>
            </div>
          )}
        </div>
        {!!error && showErrorText && (
          <div className={classes.errorText}>{error}</div>
        )}
      </Fragment>
    );
  };

  renderEdit = () => {
    const {
      value,
      checkboxGroupName,
      onFocusInputField,
      options,
      disabledList,
      tooltipPosition,
      checkboxItemLabelStyle,
      dropDownStyle,
    } = this.props;
    const selectedTags = this.getSelectedTags();

    return (
      <div className={classes.container}>
        <ButtonDropdown
          {...dropDownStyle}
          buttonComponent={this.renderButtonComponent({
            showErrorText: false,
            value: selectedTags,
            showArrow: true,
            onFocusInputField: onFocusInputField,
            tagTheme: "black",
            inlineView: true,
          })}
          dropdownComponent={
            <CheckboxGroup
              options={options}
              value={value}
              updateInputField={this.updateValue}
              checkboxGroupName={checkboxGroupName}
              checkboxItemLabelStyle={checkboxItemLabelStyle}
              disabledList={disabledList}
              tooltipPosition={tooltipPosition}
            />
          }
          shouldCloseOnSelfClick={false}
          onUpdateShowDropDown={this.onUpdateShowDropDown}
        />
      </div>
    );
  };
}

SelectDropdownButton.defaultProps = {
  ...UIBaseComponent.defaultProps,
  options: [],
  disabledList: [],
  checkboxGroupName: "",
  tooltipPosition: "bottom",
  checkboxItemLabelStyle: checkBoxStyle.checkboxItemLabelStyle,
  dropDownStyle: dropDownStyle,
  tagStyle: tagStyle,
  error: false,
};

SelectDropdownButton.propTypes = {
  ...UIBaseComponent.propTypes,
  options: PropTypes.array,
  disabledList: PropTypes.array,
  checkboxGroupName: PropTypes.string,
  tooltipPosition: PropTypes.string,
  checkboxItemLabelStyle: PropTypes.object,
  dropDownStyle: PropTypes.object,
  tagStyle: PropTypes.object,
  error: PropTypes.bool,
};

export default SelectDropdownButton;
